/**
 * @module router/journal
 * GL routes — 3-way app split (ROLE_APP_REORG_PLAN.md Phase 3):
 *   journal    — the GL entry page (cashier scope: record/review journal entries)
 *   gl         — reporting/operational: Ledger, Trial Balance, Financials
 *   gl-config  — config: COA (chart of accounts) + Periods (period close); admin
 * appadmin bypasses all app gating. An admin can hold any combination.
 */
const journalRoutes = [
  {
    path: "/accounting/journal",
    name: "Journal",
    component: () => import("@/views/accounting/JournalView.vue"),
    // Reachable with either "journal" (cashier scope) or "gl" (reporting) — a
    // GL-access admin can record/review entries too. Guard treats app[] as ANY-match.
    meta: { requiresAuth: true, requiresAdmin: true, app: ["journal", "gl"] },
  },
  {
    path: "/accounting/ledger",
    name: "Ledger",
    component: () => import("@/views/accounting/LedgerView.vue"),
    meta: { requiresAuth: true, app: "gl" },
  },
  {
    path: "/accounting/coa",
    name: "Coa",
    component: () => import("@/views/accounting/CoaView.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: "gl-config" },
  },
  {
    path: "/accounting/trial-balance",
    name: "TrialBalance",
    component: () => import("@/views/accounting/TrialBalanceView.vue"),
    meta: { requiresAuth: true, app: "gl" },
  },
  {
    path: "/accounting/financials",
    name: "Financials",
    component: () => import("@/views/accounting/FinancialsView.vue"),
    meta: { requiresAuth: true, app: "gl" },
  },
  {
    path: "/accounting/periods",
    name: "Periods",
    component: () => import("@/views/accounting/PeriodsView.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: "gl-config" },
  },
];

export default journalRoutes;
